<template>
  <div class="contact-us-page-content flex bg-[#f8f8f8]  flex-col items-center w-full text-center">
    <div
      class="bg-[#f8f8f8] w-full max-w-[70%] contact-us-container-qrcode flex  flex-col items-center mt-50% -translate-y-30%">
      <Pic src="/images/mobile/contact-us.png"></Pic>
      <p class="text-[#999] text-[0.9rem] font-[400] my-1rem">长按识别二维码，添加企业微信</p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useSeoMeta } from 'nuxt/app'
import { ref, onMounted, onUnmounted, nextTick } from 'vue'

const title = ref("联系我们")
const description = ref("联系我们")
useSeoMeta({
  title,
  description,
})
</script>
<style lang="scss" scoped>
@import "@base/@core/scss/template/libs/vuetify/variables";

.contact-us-page-content {
  max-width: $page-max-width;
  max-height: 100vh;
  padding-top: $table-header-height;

  //   @media (max-width: 1023.9px) {
  //     padding-top: $table-header-height;padding-top
  //   }
  .contact-us-container-qrcode {
    height: 100vh;

    .card {
      position: relative;
      z-index: 1111;
      display: flex;
      overflow: hidden;
      width: 200px;
      height: 250px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 14px;
      box-shadow: 0 0 60px rgba(0, 0, 0, 5%), -20px -20px 60px #fff;
    }

    .bg {
      position: absolute;
      z-index: 2;
      top: 5px;
      left: 5px;
      overflow: hidden;
      width: 190px;
      height: 240px;
      border-radius: 10px;
      backdrop-filter: blur(24px);
      background: rgba(255, 255, 255, 95%);
      outline: 2px solid white;
    }

    .blob {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      width: 150px;
      height: 150px;
      border-radius: 50%;
      animation: blob-bounce 5s infinite ease;
      background-color: #f00;
      filter: blur(12px);
      opacity: 1;
    }

    @keyframes blob-bounce {
      0% {
        transform: translate(-100%, -100%) translate3d(0, 0, 0);
      }

      25% {
        transform: translate(-100%, -100%) translate3d(100%, 0, 0);
      }

      50% {
        transform: translate(-100%, -100%) translate3d(100%, 100%, 0);
      }

      75% {
        transform: translate(-100%, -100%) translate3d(0, 100%, 0);
      }

      100% {
        transform: translate(-100%, -100%) translate3d(0, 0, 0);
      }
    }
  }
}
</style>
